import styles from './CategoryFilterTag.module.css';

export function CategoryFilterTag({ label, onRemove }) {
  if (!label) {
    return null;
  }

  return (
    <div className={styles.tags}>
      <span className={styles.tag}>
        {label}
        <button type="button" className={styles.removeBtn} onClick={onRemove} aria-label="Убрать фильтр категории">
          <CloseIcon />
        </button>
      </span>
    </div>
  );
}

function CloseIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
      <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
